import type { PropsWithChildren } from 'react'
import { clsx } from 'clsx'
import parse from 'html-react-parser'
import { Typography } from '@/components/Typography'
import type { StorylineLinkRelatedType } from '@/types/cms/Storylines'
import {
  FieldsStorylineLinkRelatedType,
  FieldstorylineNoteRelatedType,
  StorylineNoteRelatedType,
  annotationType,
} from '@/types/cms/Storylines'
import { toKebabCase } from '@/utils/string'
import annotationConvert from './annotatedConvert'

export type TypographyProps = PropsWithChildren<{
  as?: keyof React.JSX.IntrinsicElements
  className?: string
  fields: annotationType
  referenced?: {
    [key: string]: StorylineLinkRelatedType | StorylineNoteRelatedType
  }
}>

export const AnnotatedMarkup = ({ as: DynamicTag = 'p', className, fields, referenced }: TypographyProps) => {
  if (!fields) {
    return <></>
  }

  const deepCopyFields = JSON.parse(JSON.stringify(fields))

  if (referenced) {
    deepCopyFields.annotations.map(
      (item: { value: string | FieldsStorylineLinkRelatedType | FieldstorylineNoteRelatedType }) => {
        if (referenced[item.value as string | number]) {
          return (item.value = referenced[item.value as string | number].fields)
        }
      },
    )
  }

  const annotated = annotationConvert(deepCopyFields)
  const splitToLineBreak = annotated.split(/[\r\n]+/)

  return (
    <>
      {splitToLineBreak.map((item, index) => {
        const id = toKebabCase(item) + index
        return (
          <Typography as={DynamicTag} key={id} className={clsx(`${className}`)}>
            {parse(item)}
          </Typography>
        )
      })}
    </>
  )
}

export default AnnotatedMarkup
